import React, {Component} from 'react';
import {getTranslate} from "localization/localizeSlice";
import {connect} from "react-redux";
import {
    addPaybackCoupon,
    closeRightPanelDialogue,
    setPaybackCustomer,
    setPaybackInputDone,
    showRightPanelDialogue
} from "../../redux/actions";
import EnterCardNumber from "./EnterCardNumber";
import EnterCouponCode from "./EnterCouponCode";
import ScanCustomerCard from "./ScanCustomerCard";
import {getProductsInBasket} from "../../redux/selectors";

const mapStateToProps = state => {
    return {
        clientCode: state.rootReducer.user.clientCode,
        sessionKey: state.rootReducer.user.sessionKey,
        warehouseCode: state.rootReducer.warehouse.code,
        productsInBasket: getProductsInBasket(state),
        translate: getTranslate(state)
    }
};

const mapDispatchToProps = dispatch => {
    return {
        paybackInputDone: () => {
            dispatch(setPaybackInputDone(true));
        },
        enterCardCode: () => {
            dispatch(showRightPanelDialogue((
                <EnterCardNumber
                    onDone={cardNumber => {
                        dispatch(setPaybackCustomer(cardNumber));
                        dispatch(closeRightPanelDialogue());
                        dispatch(showRightPanelDialogue(<EnterCouponCode/>));
                    }}
                    onBack={e => {
                        dispatch(closeRightPanelDialogue());
                    }}
                />
            )));
        },
        enterCouponCode: (coupons) => {
            dispatch(showRightPanelDialogue(<EnterCouponCode/>));
        }
    }
}

class Payment extends Component{
    render() {
        return <ScanCustomerCard
            paybackInputDone={this.props.paybackInputDone}
            enterCardCode={this.props.enterCardCode}
            enterCouponCode={this.props.enterCouponCode}
        />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Payment);